'use strict';

var $u = require('../utilities');
var $d = require('../dependency');
var _ = $d._;
var moment = $d.moment;

exports.convertToCustomerName = convertToCustomerName;

function convertToCustomerName(context, config, next) {
    var apiMergedResponse = context.apiMergedResponse,
      customerInfoApiUrl,
      customerDetails,
      customerName,
      customerNameField,
      customerNameQueryString,
      getQueryKey,
      promise;

    //perform after afterApiAggregation

    customerInfoApiUrl = $d.basePath + config.customerApiGetUrl;
    customerNameField = config.customerNameField;
    getQueryKey = config.GETQueryKey;
    customerNameQueryString = $u.generic.generateGETQueryString(
      getQueryKey,
      apiMergedResponse[customerNameField]
    );

    promise = $d.apiRequest({
        url: customerInfoApiUrl + '?' + customerNameQueryString,
        type: 'GET',
        dataType: 'json',
        _otherInfo: context.otherInfo
    });

    promise.then(
      function (response) {
          apiMergedResponse[customerNameField] =
            _.map(apiMergedResponse[customerNameField], function (custId) {
                customerDetails = null;
                customerName = null;
                customerDetails = _.find(response.pageResults, function (page) {
                    return page.id === custId;
                });
                if (customerDetails && customerDetails.name) {
                    customerName = customerDetails.name;
                } else {
                    customerName = custId;
                }
                return customerName;
            });

          next();
      },
      function (err) {
          // apiParsedResponseList[customerNameField] = [];
          next(err);
      }
    );
}